// extracted by mini-css-extract-plugin
module.exports = {"yellow":"redpoint_yellow_1yZjl","ticket":"redpoint_ticket_1sC_I","iconsize":"redpoint_iconsize_kz852","inner":"redpoint_inner_2gZpv"};